import React from 'react'
import styles from './toolbar.module.css';
// No local header import required - toolbar aligns using CSS vars & padding

export const Toolbar = () => {
  // This acts as a spacer and anchor for any custom toolbar actions.
  // The Lexical `ToolbarPlugin` renders a `.toolbar` element, which we position via CSS.
  return (
    <div className={styles.lexicalToolbarAnchor} id='quillToolbar' />
  )
}

export default Toolbar;
